var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"simple-snotify"},[_c('button',{staticClass:"btn btn-outline-success mx-auto",on:{"click":_vm.showSnotify}},[_vm._v("Click here!")]),_c('vue-snotify')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }